export const CURRENCIES__FETCH = 'CURRENCIES__FETCH';
